<div class="flex-column flex-gap-20">

    <div class="dragpanel click" (click)="showImageBrowseDlg()">
        <div class="drop-container">
            <input hidden #fileDropRef type="file" multiple (change)="fileBrowseHandler($event)">
            <p class="mat-body-1 dragpanel-text">
                Dra og slipp dokumenter her eller trykk for å åpne filvelger<br />
                (maks {{formatBytes(config?.MaxUploadFileSize)}})
            </p>
        </div>
    </div>

    <div *ngIf="files.length > 0">
        <div class="flex-column flex-gap-10">

            <div class="mat-step-label-selected">Valgte filer</div>
            
            <div *ngFor="let item of files" class="flex-row flex-gap-10 file-row" style="align-items:center;">

                <div style="display: flex; flex: 1 1 auto; word-break:break-all">{{item.name}}</div>

                <div *ngIf="item.status === 3">{{formatBytes(item.size)}}</div>

                <div *ngIf="item.status === 3" [ngClass]="{'click': !isUploading}" (click)="removeFile(item)">
                    <mat-icon [ngClass]="{'red-icon': !isUploading, 'muted-icon': isUploading}"
                        fontSet="material-icons-outlined">delete</mat-icon>
                </div>

                <div *ngIf="item.status < 3">
                    <span>
                        <span *ngIf="item.status === 0">Leser</span>
                        <span *ngIf="item.status === 1">Laster opp</span>
                        <span *ngIf="item.status === 2">Behandler</span>
                        <span>&nbsp;filen...({{item.progress}}%)</span>
                    </span>
                </div>

            </div>
        </div>
    </div>
</div>